// Copyright (c) Mysten Labs, Inc. — DGC Labs footer
// SPDX-License-Identifier: Apache-2.0

import { type ReactNode } from 'react';

type FooterItem = {
	category: string;
	items: { title: string; children: ReactNode; href: string }[];
};
export type FooterItems = FooterItem[];

export const footerLogoLink = {
	title: 'DGC Labs',
	href: 'https://dgclabs.cc',
};

export type FooterNavLink = {
	title: string;
	/** In-app route (react-router) */
	to?: string;
	/** External URL */
	href?: string;
};

/** Public / in-app links shown in the page footer */
export const footerLinks: FooterNavLink[] = [
	{ title: '创世公示', to: '/genesis' },
	{ title: '应用中心', to: '/wallet' },
	{ title: '钱包下载', href: 'https://download.dgclabs.cc' },
	{ title: 'RPC', href: 'https://rpc.dgclabs.cc' },
];

/** No public Discord/X accounts yet — keep empty rather than placeholder socials */
export const socialLinks: { children: ReactNode; href: string }[] = [];

export const legalLinks: FooterNavLink[] = [{ title: '创世公示', to: '/genesis' }];
